// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';
import { selectQuery } from '../../feature';

// Components
import { Table } from '@/ui';
import { Pagination } from '@/components';
import { StyledWrapper } from '../Styled';

// Models
import { IAdminProfileResponse } from '@/models/admins.model';

// Modules
import { AdminsFiltersContainer } from '../../containers';
import { Resource, usePermissions } from '@/modules/Permissions';

// Helpers
import { getAdminsTableColumns } from './columns';

interface IAdminsList {
  adminsList: IAdminProfileResponse[];
  currentPage: number;
  total: number;
  setDeletedAdmin: (admin: IAdminProfileResponse) => void;
  onResendInvitation: (id: string) => void;
  onPageChange: (page: number) => void;
}

const AdminsList = ({
  adminsList,
  total,
  currentPage,
  onPageChange,
  setDeletedAdmin,
  onResendInvitation,
}: IAdminsList) => {
  const { t } = useTranslation(['usersList']);
  const query = useAppState(selectQuery);
  const { canManage } = usePermissions();

  return (
    <StyledWrapper>
      <Table
        columns={getAdminsTableColumns({
          t,
          setDeletedAdmin,
          onResendInvitation,
          query,
          canManage: canManage(Resource.ADMIN_PANEL),
        })}
        dataSource={adminsList}
        components={{
          header: {
            wrapper: AdminsFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default AdminsList;
